// extracted by mini-css-extract-plugin
export var table = "_xc-0";